export default __webpack_public_path__ + "static/media/aWOOL.75deab68.png";